import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { fetchBanks } from "src/store/slices/bankSlice";

const useBanks = () => {
  const dispatch = useAppDispatch();
  const { items, loading, error, loaded} = useAppSelector((state) => state.banks)

  useEffect(() => {
    if (!loaded && !loading && !error) {
      dispatch(fetchBanks());
    }
  }, [dispatch, loaded, loading, error])

  return {banks: items, loading, error, loaded}
}

export default useBanks;